import { render } from "./SwitchDetails.vue?vue&type=template&id=717c0646&scoped=true"
import script from "./SwitchDetails.vue?vue&type=script&lang=js"
export * from "./SwitchDetails.vue?vue&type=script&lang=js"

import "./SwitchDetails.vue?vue&type=style&index=0&id=717c0646&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717c0646"]])

export default __exports__